let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4NREe")).then(() => parcelRequire('gPHbF'));